(function($) {
  var CurrentCurrency = {
		get: function() {
			return TL.app.currency;
		},
		set: function(curr) {
			TL.app.currency = curr;
		}
  }
  
  /**
	 * Register method to global for get currency
	 * @since 2019-06-05
	 */
	$.extend(true, window.TL, {
		currency: CurrentCurrency
	});
  
  /**
   * Just open current panel
   */
  $(document).on('click', '.js-currency-panel', event => {
		event.preventDefault();
		$.magnificPopup.open({
			items: {
				src: event.currentTarget.hash,
				type: 'inline'
			},
			callbacks: {
				open: function() {
					var $el = this.content;
					$el.find(`a[data-curr="${CurrentCurrency.get()}"]`).addClass('current');
					$el.on('click', 'a', function() {
						var curr = this.dataset.curr;
						CurrentCurrency.set(curr);

						$(this).addClass('current').parents('.currency-panel').find('li a').not(this).removeClass('current');
						$.magnificPopup.instance.close();
					});
				}
			},
			mainClass: 'component-popup mfp-zoom-up',
			removalDelay: 200,
			alignTop: true
		});
  });
  
  /**
	 * Watching app data for update UI
	 * @since 2019-03-05
	 */
	watch(TL.app, function(prop, action, newValue, oldValue) {
		if ('currency' === prop) {
			$('.js-currency-panel .text').html(newValue);
		}
  });
  
  /**
   * Set current currency
   * @since 2019-03-05
   */
  CurrentCurrency.set('USD');
})(jQuery);